import { useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { usePlatformCounts } from "@/hooks/usePlatformCounts";
import { PlatformDashboardView } from "@/components/platform/PlatformDashboardView";
import { platformRoleLabels } from "@/lib/platformNavigation";

export function PlatformDashboard() {
  const navigate = useNavigate();
  const { orgUser, role } = useAuth();
  const counts = usePlatformCounts();

  return (
    <PlatformDashboardView
      adminName={orgUser?.name || "Administrator"}
      roleLabel={role ? platformRoleLabels[role] || "Platform Administrator" : "Platform Administrator"}
      orgs={counts.orgs}
      studios={counts.studios}
      endUsers={counts.endUsers}
      loading={counts.loading}
      error={counts.error}
      onRefresh={counts.refresh}
      onViewOrganizations={() => navigate("/admin/orgs")}
      onViewWorkspaces={() => navigate("/admin/studios")}
      onViewApps={() => navigate("/admin/apps")}
      onViewCommunications={() => navigate("/admin/communications")}
    />
  );
}
